import {
  IAnalyticsNewCustomerProfileDatastore,
  AnalyticsNewCustomerProfileDto,
  analyticsNewCustomerProfileQueryType,
  analyticsNewCustomerProfileQueryExpand
} from "dev-center-lib";

import { prepareUrl, request } from "../common/apiClient";

import config from "../config.json";

export class AnalyticsNewCustomerProfileDatastoreRestClient
  implements IAnalyticsNewCustomerProfileDatastore {

  public addAsync(userDto: AnalyticsNewCustomerProfileDto) {
    return Promise.reject("Not implemented");
  }

  public findAsync(query: analyticsNewCustomerProfileQueryType) {
    return new Promise<{
      dtos: AnalyticsNewCustomerProfileDto[],
      objectsPerPage: number,
      pageNumber: number,
      totalObjectCount: number,
      totalPageCount: number
    }>(
      async (resolve, reject) => {
        try {
          const response = await request<{
            dtos: AnalyticsNewCustomerProfileDto[],
            objectsPerPage: number,
            pageNumber: number,
            totalObjectCount: number,
            totalPageCount: number
          }>(
            prepareUrl(
              `${config.apiServer}/analytics-new-customer-profiles`,
              query
            )
          );

          response.dtos = response.dtos.map(
            (dto) => (new AnalyticsNewCustomerProfileDto(dto))
          );
          resolve({ ...response });
        } catch (error) {
          reject(error);
        }
      }
    );
  }

  public getAsync(id: number, expand?: analyticsNewCustomerProfileQueryExpand) {
    return Promise.reject("Not implemented");
  }

  public removeAsync(id: number) {
    return Promise.reject("Not implemented");
  }

  public updateAsync(userDto: AnalyticsNewCustomerProfileDto) {
    return Promise.reject("Not implemented");
  }
}
